import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 2.5rem 2rem 3rem;
  font-family: ${theme.fonts.main};
  background: #fafbfc;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  line-height: 1.8;
  color: #333;
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 2rem;
  font-weight: 800;
  color: #1a237e;
  margin-bottom: 0.3rem;
`;

export const SubTitle = styled.p`
  text-align: center;
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 1.5rem;
`;

export const Meta = styled.div`
  text-align: center;
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 2rem;

  p {
    margin: 0.2rem 0;
  }
`;

export const Disclaimer = styled.div`
  background: #fff3e0;
  border-left: 4px solid #f5a623;
  padding: 0.8rem 1.2rem;
  margin-bottom: 2rem;
  border-radius: 4px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #6d4c00;
`;

export const Section = styled.section`
  margin-bottom: 2.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a237e;
  margin-bottom: 1rem;
  padding-bottom: 0.4rem;
  border-bottom: 2px solid #e8eaf6;
`;

export const SubSection = styled.div`
  margin-bottom: 1.5rem;
`;

export const SubSectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  color: #3949ab;
  margin-bottom: 0.5rem;
`;

export const Text = styled.p`
  margin: 0.4rem 0;
  font-size: 1rem;
`;

export const BoldText = styled.p`
  margin: 0.4rem 0;
  font-weight: 600;
  font-size: 1rem;
`;

export const IndentBlock = styled.div`
  padding-left: 1.5rem;
  margin: 0.3rem 0;
`;

export const OptionBox = styled.div`
  background: #f5f7fa;
  border-radius: 8px;
  padding: 0.8rem 1.2rem;
  margin: 0.5rem 0;
  border-left: 3px solid #3949ab;
`;

export const OptionLabel = styled.span`
  font-weight: 600;
  color: #3949ab;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 2rem 0;
`;

export const ExampleBox = styled.div`
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin: 1rem 0;
  font-size: 0.95rem;

  p {
    margin: 0.3rem 0;
  }
`;

export const ExampleTitle = styled.div`
  font-weight: 700;
  color: #555;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
`;

export const LanguageToggle = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

export const LangButton = styled.button`
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  border: 2px solid #3949ab;
  background: ${props => props.$active ? '#3949ab' : '#fff'};
  color: ${props => props.$active ? '#fff' : '#3949ab'};
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.$active ? '#303f9f' : '#e8eaf6'};
  }
`;

export const Footer = styled.footer`
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e0e0e0;
  text-align: center;
  font-size: 0.9rem;
  color: #888;
`;
